/**
 * CallDispositionBar — the "Next steps" surface inside Call Mode: schedule a
 * callback, create a follow-up task, and draft a form-link text, all without
 * leaving the call. Reuses the existing rail cards unchanged (each owns its own
 * endpoints and refetches on reloadToken); their link actions draft into the
 * Communicator composer via prefillComposer rather than sending. The lead-status
 * quick-set lives in the workspace header (LifecycleSelect), not here.
 */
import { Contact } from '../../types';
import CallbacksCard from '../CallbacksCard';
import TasksCard from '../TasksCard';
import SendFormCard from '../SendFormCard';

interface Props {
  contact: Contact;
  /** The study this call is about — seeds the form picker's default. */
  studyId?: string | null;
  maxAttempts?: number;
  reloadToken?: number;
  onSent?: () => void;
  /** Drop a card's rendered SMS (booking link, form link) into the Communicator
   *  composer — those actions draft, they never send on their own. */
  prefillComposer?: (text: string) => void;
}

export default function CallDispositionBar({ contact, studyId, maxAttempts, reloadToken, onSent, prefillComposer }: Props) {
  return (
    <div className="space-y-4">
      <CallbacksCard contact={contact} maxAttempts={maxAttempts} reloadToken={reloadToken} onSent={onSent} prefillComposer={prefillComposer} />
      <TasksCard contactId={contact.id} />
      <SendFormCard contact={contact} primaryStudyId={studyId} reloadToken={reloadToken} prefillComposer={prefillComposer} />
    </div>
  );
}
